export default __webpack_public_path__ + "static/media/preference_branco.5532af08.svg";